import type { ITTDCampaignAttributes } from './ttd_base';
import { TTDCampaign } from './ttd_base';
import type { CampaignClass } from './types';

// Legacy Lookalike
/** @deprecated in favor of SeedSegment */
export type TLookalikeCampaign = ITTDCampaignAttributes & {
  readonly _cls: CampaignClass.Lookalike;
};

/** @deprecated in favor of SeedSegment */
export class LookalikeCampaign extends TTDCampaign<TLookalikeCampaign> {}
